// 기업 연수원 공개 화면 공통 규칙. 공개 조회에는 로그인 쿠키·토큰을 보내지 않는다.
export const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,99}$/
export const validSlug = value => typeof value === 'string' && SLUG_PATTERN.test(value)
export const validOpeningId = value => typeof value === 'string' && /^[1-9][0-9]{0,18}$/.test(value)
export const academyColor = value => typeof value === 'string' && /^#[0-9a-fA-F]{6}$/.test(value) ? value : '#157f79'
export const academyPath = (slug, rest = '') => `/cyber/${slug}${rest}`
export const loginLink = returnTo => ({ path: '/login', query: { returnTo } })

/** 공개 연수원 API 응답 봉투를 해석한다. 404는 호출 화면이 안내 문구를 고른다. */
export async function academyFetch(path, { signal, fetchImpl = globalThis.fetch } = {}) {
  const response = await fetchImpl(path, { credentials: 'omit', cache: 'no-store', signal })
  if (!response.ok) { const error = new Error('ACADEMY_UNAVAILABLE'); error.status = response.status; throw error }
  const result = await response.json()
  if (!result?.success) { const error = new Error('ACADEMY_UNAVAILABLE'); error.status = 0; throw error }
  return result.data
}
export const coursesUrl = (slug, { query = '', page = 1, size = 12 } = {}) => `/api/academy/${encodeURIComponent(slug)}/courses?${new URLSearchParams({ query: query.trim(), page, size })}`
export const courseUrl = (slug, openingId) => `/api/academy/${encodeURIComponent(slug)}/courses/${encodeURIComponent(openingId)}`

/** 본인 신청 후보에서 같은 개설을 찾는다. Long 식별자는 문자열로 비교한다. */
export const matchChoice = (items, openingId) => (Array.isArray(items) ? items : []).find(item => String(item?.openingId) === String(openingId)) || null
/** 신청 후보를 개설명으로 좁혀 끝까지 넘기며 찾는다. 후보가 없으면 null이다. */
export async function findChoice(request, slug, course, { size = 100, maxPages = 20 } = {}) {
  const query = String(course?.openingNm || '').slice(0, 100)
  for (let page = 1; page <= maxPages; page++) {
    const data = await request(`/api/user/enrollment-applications/openings?${new URLSearchParams({ slug, query, page, size })}`)
    const found = matchChoice(data?.items, course.openingId)
    if (found || !data?.items?.length || page * size >= Number(data.total || 0)) return found
  }
  return null
}
export const period = (start, end) => start || end ? `${start || '미정'} ~ ${end || '미정'}` : '학습 기간 미정'
export const applicationStatusName = value => ({ PENDING: '승인 대기', APPROVED: '승인 · 수강 등록', REJECTED: '반려', WITHDRAWN: '신청 철회' }[value] || '확인 필요')
export const enrollmentStatusName = value => ({ ENROLLED: '수강 중', CANCELLED: '수강 취소', COMPLETED: '수료' }[value] || '상태 확인 필요')
export const ACADEMY_TABS = ['current', 'ended', 'applications']
export const academyTab = value => ACADEMY_TABS.includes(value) ? value : 'current'
